module.exports = __webpack_public_path__ + "img/sv21.e481baa1.svg";